export const detailUrl = ({ tenantId }) =>
  `/tenants/detail/${tenantId}/invoicing`;
